import React from 'react';
import classnames from 'classnames/bind';
import styles from './ModernAddButton.module.scss';

const cx: CX = classnames.bind(styles);

interface ModernAddButtonProps {
    title: string;
    onClick: (e: React.MouseEvent) => void;
    size?: 'small' | 'medium' | 'large';
    variant?: 'primary' | 'secondary' | 'neutral';
    icon?: React.ReactNode;
    disabled?: boolean;
    className?: string;
}

function ModernAddButton({
    title,
    onClick,
    size = 'small',
    variant = 'secondary',
    icon,
    disabled = false,
    className,
}: ModernAddButtonProps) {
    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (!disabled) {
            onClick(e);
        }
    };

    const defaultIcon = (
        <svg
            className={cx('plus-icon')}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12 5V19M5 12H19"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );

    return (
        <button
            type="button"
            className={cx('modern-add-button', size, variant, className, { disabled })}
            onClick={handleClick}
            disabled={disabled}
        >
            <span className={cx('icon')}>
                {icon || defaultIcon}
            </span>
            <span className={cx('title')}>{title}</span>
        </button>
    );
}

ModernAddButton.defaultProps = {
    size: 'small',
    variant: 'secondary',
    icon: undefined,
    disabled: false,
    className: undefined,
};

export default ModernAddButton; 